<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em; padding-top:15px;">This, I promise, will be short and sweet. Firstly, I’d like to thank my family for their love and support.</p>
<p style="text-indent:00em; padding-top:15px;">Secondly, I’d like to thank the entirety of the Fenty family in Colorado, especially Mr. Travis, thank you for your love and support from the beginning of this journey.</p>
<p style="text-indent:00em; padding-top:15px;">Lastly, I would like to thank Mrs. Wehtje who I shared my first copy with and who originally made me love writing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?56b77c42